export const RolesValues = ["Admin", "Director", "Asesor"] as const
export type RolesType = typeof RolesValues[number]
